<template>
  <div class="box box-info">
     <div class="p-grid">
      <div class="p-col">
      <a href="#"  @click.prevent="exportCSV()" >
        <img src="../../../../static/img/excel.png" style="height: 3.5em;width: 3.5em;float: right;"/>
      </a>
    </div>
  </div>
    <DataTable
      :value="inventoryNegativeStockLists"
      :paginator="true" ref="po"
      :rowsPerPageOptions="[100,500,1000]"
      :rows="100" :filters="filters"
      editMode="cell"
      class="p-datatable-responsive p-datatable-gridlines"
    >
        <Column header="S.N" >
          <template #body="sl">
             {{sl.index+1}}
          </template>
        </Column>

      <Column headerStyle="width: 16em" header="Item Name" field="itemName" :sortable="true"  filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['itemName']" />
        </template>
      </Column>
      <Column header="Code" field="itemCode" :sortable="true"  filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['itemCode']" />
        </template>
      </Column>

      <Column header="Unit"  field="unit" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['unit']" />
        </template>
      </Column>
       <Column header="Store"  field="warehouseName" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['warehouseName']" />
        </template>
      </Column>

        <Column header="Closing Stock" bodyStyle="text-align: right" :sortable="true" field="closingQuantity"
        filterMatchMode="contains">
        <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['closingQuantity']" />
          </template>
        </Column>
      <template #empty>No record found</template>
    </DataTable>
     <!-- </div> -->
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
export default {
  name: 'ClosingStockStoreWise',
  data () {
    return {
      dialogShow: false,
      itemId: '',
      loading: false,
      imageDialog: false,
      filters: {},
      inStock: 0,
      columnList: ''
    }
  },
  computed: {
    inventoryNegativeStockLists() {
      return this.$store.state.inventoryReport.inventoryNegativeStockLists
    }
  },
  mounted() {
    this.inventoryNegativeStockList()
    this.columnNames()
  },
  methods: {
    async inventoryNegativeStockList() {
      await this.$store.dispatch('negativeClosingStock')
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Item List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'itemList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    }
  },
  components: {
    DataTable,
    Column,
    InputText,
    Button
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// itemNegativeStock.vue?13bcbd8b